<div class="flex flex-1 flex-col gap-2">
  <dx-form
    [formData]="formData"
    [colCount]="1"
    (onFieldDataChanged)="onFieldDataChanged()"
    class="flex-1"
  >
    <dxi-item itemType="group" [colCount]="1">
      <dxi-item itemType="group" [colCount]="3">
        <dxi-item
          dataField="country"
          [label]="{ text: 'Nazione' | transloco, location: 'top' }"
          [colSpan]="1"
          [editorType]="'dxSelectBox'"
          [editorOptions]="{
            dataSource: addressCountryDataSource,
            displayExpr: 'name',
            valueExpr: 'code',
            searchEnabled: true,
            searchExpr: ['name']
          }"
        >
        </dxi-item>
      </dxi-item>

      <dxi-item itemType="group" [colCount]="8">
        <dxi-item
          dataField="address"
          [label]="{ text: 'Indirizzo' | transloco, location: 'top' }"
          [colSpan]="8"
          [editorType]="'dxTextBox'"
          [editorOptions]="{
            valueChangeEvent: 'input'
          }"
        >
          <!-- [editorOptions]="{
            itemTemplate: addressAdressItemTeplate,
            elementAttr: { class: 'powered-by-google' },
            onFieldDataChanged: onAddressAddressSelectionChanged
          }" -->
        </dxi-item>

        <dxi-item
          dataField="city"
          [editorType]="getFieldTypeByNation()"
          [editorOptions]="{
            dataSource: addressCityDataSource,
            valueExpr: 'name',
            displayExpr: 'name',
            searchEnabled: true,
            searchExpr: ['name']
          }"
          [label]="{ text: 'Comune' | transloco, location: 'top' }"
          [colSpan]="4"
        >
        </dxi-item>

        <dxi-item
          dataField="zipCode"
          [editorType]="getFieldTypeByNation()"
          [editorOptions]="{
            dataSource: addressZipCodeDataSource,
            valueExpr: 'code',
            displayExpr: 'code',
            searchEnabled: true,
            searchExpr: ['code']
          }"
          [label]="{ text: 'CAP' | transloco, location: 'top' }"
          [colSpan]="2"
        >
        </dxi-item>

        @if (isDistrictIncluded || formData.country !== "CH") {
          <dxi-item
            dataField="state"
            [editorType]="
              formData.country === 'IT' ? 'dxSelectBox' : 'dxTextBox'
            "
            [editorOptions]="{
              dataSource: addressStateDataSource,
              valueExpr: 'code',
              displayExpr: 'name',
              searchEnabled: true,
              searchExpr: ['name']
            }"
            [label]="{ text: 'Provincia' | transloco, location: 'top' }"
            [colSpan]="2"
          >
          </dxi-item>
        }
      </dxi-item>
    </dxi-item>
  </dx-form>
</div>
